import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Story from "@/components/Story";
import MenuTeaser from "@/components/MenuTeaser";
import WhyUs from "@/components/WhyUs";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Locations from "@/components/Locations";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MenuPage from "@/pages/MenuPage";
import OrderPage from "@/pages/OrderPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmedPage from "@/pages/OrderConfirmedPage";
import FranchisePage from "@/pages/FranchisePage";
import { useReveal } from "@/hooks/useReveal";
import { CartProvider } from "@/context/CartContext";

function ScrollToHash() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [hash, pathname]);
  return null;
}

function Landing() {
  const rootRef = useReveal();
  return (
    <div ref={rootRef} data-testid="landing-page" className="bg-cream min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Story />
        <MenuTeaser />
        <WhyUs />
        <Gallery />
        <Testimonials />
        <Locations />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/franchise" element={<FranchisePage />} />
            <Route path="/order/:storeId" element={<OrderPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route
              path="/order-confirmed/:orderId"
              element={<OrderConfirmedPage />}
            />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#FDFBF7",
              border: "1px solid #E8D8C0",
              color: "#3A1B0E",
            },
          }}
        />
      </CartProvider>
    </div>
  );
}

export default App;
